import { store } from '@/store/main';
import { getActiveChannel } from '@/store/slices/user/selectors';

export const waitForChannelId = () => {
  return new Promise<number>((resolve) => {
    const getChannel = () => {
      const channel = getActiveChannel(store.getState());
      if (typeof channel === 'number') {
        resolve(channel);
      } else {
        setTimeout(getChannel, 100);
      }
    };

    getChannel();
  });
};
